/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module PositiveSecurityPolicyModule
 */

import { IPositiveSecurityParams } from 'generated-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

export class PositiveSecurityParamsConfigItem extends MessageItem<IPositiveSecurityParams> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: 'PositiveSecurityParams',
            ...args,
        };

        super(extendedArgs);
    }
}
